// extracted by mini-css-extract-plugin
export var badge = "_uk-4";
export var selected = "_uk-1";
export var selectedOverlay = "_uk-5";
export var thumbnailButton = "_uk-0";
export var thumbnailFallback = "_uk-3";
export var thumbnailImage = "_uk-2";